/* Progressive enhancements: native links and Shopify variant/cart APIs remain authoritative. */
(() => {
  class FlaayTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const nav = this.querySelector('[data-tab-nav]');
      const tabs = [...this.querySelectorAll('[data-tab]')];
      const panels = [...this.querySelectorAll('[data-panel]')];
      nav.setAttribute('role', 'tablist');
      const activate = (tab, focus = false) => {
        tabs.forEach(t => {t.setAttribute('role', 'tab');t.setAttribute('aria-selected', String(t === tab));t.tabIndex = t === tab ? 0 : -1;});
        panels.forEach(p => {p.setAttribute('role', 'tabpanel');p.tabIndex = 0;p.hidden = p.dataset.panel !== tab.dataset.tab;});
        if (focus) tab.focus();
      };
      nav.addEventListener('click', e => {const tab = e.target.closest('[data-tab]');if (tab) activate(tab);});
      nav.addEventListener('keydown', e => {
        const index = tabs.indexOf(document.activeElement);
        if (index < 0) return;
        let next;
        if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {e.preventDefault();activate(tabs[next], true);}
      });
      if (tabs[0]) {
  activate(tabs[0]);
  panels.forEach(panel => {
    panel.hidden = true;
  });
  tabs.forEach(tab => {
    tab.setAttribute('aria-selected', 'false');
  });
}
    }
  }
  class FlaayProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      // Quick-add dialogs use the theme's own variant selection flow.
      if (this.closest('quick-add-dialog, .quick-add-modal')) return;
      const size = this.querySelector('[data-flaay-option="size"]');
      const buy = this.querySelector('.buy-buttons-block');
      if (size && buy && this.dataset.productAvailable !== 'false' && this.dataset.selectedVariant !== 'true') {
        this.setAttribute('data-flaay-await-size', '');
        size.querySelectorAll('input[type=radio]').forEach(r => {r.checked = false;});
        const prompt = document.createElement('button');
        prompt.type = 'button';prompt.className = 'flaay-size-prompt';prompt.textContent = 'Select a size';
        buy.before(prompt);
        prompt.addEventListener('click', () => {size.scrollIntoView({block:'center',behavior:'smooth'});size.querySelector('input:not([aria-disabled="true"])')?.focus();}, {signal});
        this.addEventListener('change', e => {
          if (!e.target.closest('[data-flaay-option="size"]')) return;
          this.removeAttribute('data-flaay-await-size');prompt.remove();
        }, {signal});
        this.addEventListener('submit', e => {
          if (this.hasAttribute('data-flaay-await-size')) {e.preventDefault();e.stopImmediatePropagation();prompt.focus();}
        }, {capture:true,signal});
      }
      const updateGuide = () => {
        const guide = this.querySelector('[data-flaay-size-dialog]');
        const trigger = this.querySelector('.flaay-size-guide-link');
        const fallback = this.querySelector('.flaay-size-guide-fallback');
        if (trigger) trigger.hidden = !guide;
        if (fallback) fallback.hidden = !!trigger;
      };
      updateGuide();
      this.addEventListener('variant:update', () => requestAnimationFrame(updateGuide), {signal});
    }
    disconnectedCallback() {this.controller?.abort();this.controller = null;}
  }
  if (!customElements.get('flaay-product-tabs')) customElements.define('flaay-product-tabs', FlaayTabs);
  if (!customElements.get('flaay-product-details')) customElements.define('flaay-product-details', FlaayProductDetails);
  const key = 'flaay-saved-products-v1';
  let saved = [];
  try {const data = JSON.parse(localStorage.getItem(key) || '[]');if (Array.isArray(data)) saved = data.filter(p => p && /^\d+$/.test(p.id) && typeof p.title === 'string' && typeof p.url === 'string' && p.url.startsWith('/') && !p.url.startsWith('//'));} catch (_) {}
  const status = text => {const el = document.querySelector('[data-flaay-status]');if (el) el.textContent = text;};
  function refresh() {
    document.querySelectorAll('[data-flaay-save]').forEach(b => {const exists = saved.some(p => p.id === b.dataset.flaaySave);b.setAttribute('aria-pressed', String(exists));b.setAttribute('aria-label', `${exists ? 'Remove saved' : 'Save'} ${b.dataset.title}`);});
    document.querySelectorAll('[data-flaay-count]').forEach(el => el.textContent = String(saved.length));
    document.querySelectorAll('[data-flaay-open-saved]').forEach(el => el.hidden = saved.length === 0);
  }
  function persist() {try {localStorage.setItem(key, JSON.stringify(saved));} catch (_) {status('Saved for this visit only; browser storage is unavailable.');}refresh();}
  function renderSaved() {
    const list = document.querySelector('[data-flaay-saved-list]');if (!list) return;
    list.replaceChildren();
    if (!saved.length) {list.textContent = 'Your saved items will appear here.';return;}
    saved.forEach(p => {
      const row = document.createElement('div');row.className = 'flaay-saved-item';
      if (p.image && /^(https:)?\/\//.test(p.image)) {const img = document.createElement('img');img.src = p.image;img.alt = '';img.loading = 'lazy';row.append(img);}
      const link = document.createElement('a');link.href = p.url;link.textContent = p.title;row.append(link);
      const remove = document.createElement('button');remove.type = 'button';remove.textContent = 'Remove';remove.dataset.flaayRemove = p.id;row.append(remove);list.append(row);
    });
  }
  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const close = e.target.closest('[data-flaay-close]');if (close) {close.closest('dialog')?.close();return;}
    const guide = e.target.closest('[data-flaay-size-guide]');if (guide) {guide.closest('.product-details')?.querySelector('[data-flaay-size-dialog]')?.showModal();return;}
    const save = e.target.closest('[data-flaay-save]');
    if (save) {
      const id = save.dataset.flaaySave;const exists = saved.some(p => p.id === id);
      saved = exists ? saved.filter(p => p.id !== id) : [...saved, {id,title:save.dataset.title,url:save.dataset.url,image:save.dataset.image}];
      status(exists ? 'Removed from saved items.' : 'Product saved.');persist();return;
    }
    if (e.target.closest('[data-flaay-open-saved]')) {renderSaved();document.getElementById('FlaaySaved')?.showModal();return;}
    const remove = e.target.closest('[data-flaay-remove]');if (remove) {saved = saved.filter(p => p.id !== remove.dataset.flaayRemove);persist();renderSaved();}
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('flaay-dialog')) {const r = e.target.getBoundingClientRect();if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();}
  });
  let scheduled = false;
  new MutationObserver(mutations => {
    if (!mutations.some(m => [...m.addedNodes].some(n => n instanceof Element && (n.matches('[data-flaay-save]') || n.querySelector('[data-flaay-save]'))))) return;
    if (!scheduled) {scheduled = true;requestAnimationFrame(() => {scheduled = false;refresh();});}
  }).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('storage', e => {if (e.key === key) {try {const data = JSON.parse(e.newValue || '[]');if(Array.isArray(data)) saved = data.filter(p => p && typeof p.id === 'string' && typeof p.url === 'string' && p.url.startsWith('/') && !p.url.startsWith('//'));} catch (_) {}refresh();renderSaved();}});
  refresh();
})();
